/* eslint-disable indent */
// TODO : this page is pending for review
import React, { useContext, useEffect, useState } from 'react'
import { Card, Col, Form, FormControl, FormGroup, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import { toast } from 'react-toastify'
import { PaginationBodyObjectModel, ReactDataTable, UserListModel, UserListResponseModel } from '../../Models/CommonModel'
import UserContext from '../../../Context/UserContext'
import { getUserList, putChangeUserStatus } from '../../../Services/UserService'
import { fetchResponseMessage, getStatus } from '../../../utils/utils'
import { ACCOUNT_STATUS, PROJECT_ROUTES_ENUMS } from '../../../utils/enums/enums'
import _ from 'lodash'

type Props = {}

const UserList = (props: Props) => {
  const { t } = useTranslation()
  const [searchBar, setSearchBar] = useState('')
  const navigate = useNavigate()
  const [tableBodyState, setTableBodyState] = useState([] as UserListModel[])
  const { setArrayOfBreadCrumb, isFetching, setIsFetching/* , userPermissions */ } = useContext(UserContext)
  // state for pagination
  const [totalRows, setTotalRows] = useState<number>(10)
  const [timeStampState, setTimeStampState] = useState<string>('')
  const [currentPageState, setCurrentPageState] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)
  const [sortedField, setSortedField] = useState<string>('')
  const [sortDirection, setSortDirection] = useState<string>('asc')
  const [isAscending, setIsAscending] = useState<boolean>(true)
  const [sortedFieldId, setSortedFieldId] = useState<number>(1)

  // fetch content of table while you to to Designation page.
  const getTableData = async (paginationInfo: PaginationBodyObjectModel) => {
    setIsFetching(true)
    try {
      const response = await getUserList(paginationInfo)
      if (response.statusCode === 200) {
        const responseWithOrderNumber = response.data.data.map((data: UserListResponseModel, index: number) => {
          data.name === 'testh' && console.log('🔥 ~ responseWithOrderNumber ~ data', data.name, data.status)
          return {
            ...data,
            status: (
              <div className={`badge badge-pill me-1 ${data.status === ACCOUNT_STATUS.ACTIVE.STATUS ? ACCOUNT_STATUS.ACTIVE.CLASS : data.status === ACCOUNT_STATUS.INACTIVE.STATUS ? ACCOUNT_STATUS.INACTIVE.CLASS : ACCOUNT_STATUS.BLOCKED.CLASS}`}>{getStatus(data.status)}</div>
            ),
            activeStatus: data.status
          }
        })
        setTotalRows(response.data.total)
        setTimeStampState(response.data.timestamps)
        setTableBodyState(responseWithOrderNumber)
        setIsFetching(false)
      } else {
        throw response
      }
    } catch (error) {
      setIsFetching(false)
      console.error('🚀 ~ file: Designation.tsx ~ line 73 ~ useEffect ~ error', error)
      if (error && _.has(error, 'response.data.responseCode')) {
        // @ts-ignore
        const responseMessage = fetchResponseMessage(error.response.data.responseCode)
        toast.error(responseMessage)
      }
      // toast.error(`${t('TOAST_ERROR.DESIGNATION.FILED_TO_LOAD')}`)
    }
  }
  useEffect(() => {
    getTableData({ page: currentPageState, limit: rowsPerPage })
    setArrayOfBreadCrumb([
      { name: `${t('PAGE_NAME.HOME')}`, url: PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.HOME_PAGE },
      { name: `${t('PAGE_NAME.USER_LIST')}`, url: '' }
    ])
    return () => { }
  }, [rowsPerPage])

  /**
 * @function goToAddDesignationPage
 * @return void
 * @description Go to add-designation page
 */

  const gotoUserDetails = (id: string) => {
    navigate(`${PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.USER_LIST_PAGE}/view/${id} `)
  }

  const blockUser = (id: string) => {
    changeUserStatus(id, ACCOUNT_STATUS.BLOCKED.STATUS)
  }

  const activeUser = (id: string) => {
    changeUserStatus(id, ACCOUNT_STATUS.ACTIVE.STATUS)
  }

  const changeUserStatus = async (userId: string, status: number) => {
    setIsFetching(true)
    try {
      const response = await putChangeUserStatus(userId, status)
      if (response.statusCode === 200) {
        setIsFetching(false)
        const responseMessage = fetchResponseMessage(response.responseCode)
        toast.success(responseMessage)
        getTableData({ page: currentPageState, limit: rowsPerPage })
      } else {
        throw response
      }
    } catch (error) {
      setIsFetching(false)
      console.error('🔥 ~ blockDriver ~ error', error)
      if (error && _.has(error, 'response.data.responseCode')) {
        // @ts-ignore
        const responseMessage = fetchResponseMessage(error.response.data.responseCode)
        toast.error(responseMessage)
      }
    }
  }

  const handleInputStatusChange = (eventValue: boolean, userId: string) => {
    if (eventValue) {
      activeUser(userId)
    } else {
      blockUser(userId)
    }
  }

  const columns: ReactDataTable[] = [
    {
      name: `${t('USER_LIST_PAGE.USER_TABLE.NAME')}`,
      selector: (row: { name: string }) => row.name,
      sortable: true
    },

    {
      name: `${t('USER_LIST_PAGE.USER_TABLE.EMAIL')}`,
      selector: (row: { email: string }) => row.email,
      sortable: true
    },
    {
      name: `${t('USER_LIST_PAGE.USER_TABLE.STATUS')}`,
      cell: (tableRow: UserListModel) => (
        <>
          <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
            <Form.Check type="switch" name="bookingForOther" className="switch" checked={tableRow.activeStatus !== -1} onChange={(event) => handleInputStatusChange(event.target.checked, tableRow.id)} />
          </FormGroup>
        </>
      ),
      center: true
    },
    {
      // TODO: from translation
      name: 'Action',
      cell: (tableRow: UserListModel) => (
        <>
          <span onClick={() => gotoUserDetails(tableRow.id)} className='mdi mdi-eye table-setting-icon mx-1 text-primary'></span>
          {/* <span onClick={() => editUser(tableRow.id)} className='mdi mdi-pencil table-setting-icon mx-1 text-primary'></span>
          <span onClick={() => deleteUser(tableRow.id)} className='mdi mdi-trash-can-outline table-setting-icon mx-1 text-danger delete'></span> */}
        </>
      ),
      center: true
    }
  ]

 /*  const editUser = (userId: string) => {

  }
  const deleteUser = (userId: string) => {

  } */

  const handlePageChange = (changedPage: number, totalRows: number) => {
    setCurrentPageState(changedPage)
    let paginationObject
    if (sortedField !== '') {
      paginationObject = {
        page: changedPage,
        limit: rowsPerPage,
        orderBy: sortedField,
        orderDirection: sortDirection,
        timestamps: timeStampState
      }
    } else {
      paginationObject = {
        page: changedPage,
        limit: rowsPerPage,
        orderDirection: sortDirection,
        timestamps: timeStampState
      }
    }

    getTableData(paginationObject)
  }

  const handleSort = (selectedColumn: any, order: string) => {
    setSortedField(selectedColumn.name.toLowerCase())
    setSortedFieldId(selectedColumn.id)
    setSortDirection(order)
    setIsAscending(isAscending => !isAscending)
    const paginationObject = {
      page: currentPageState,
      limit: rowsPerPage,
      timestamps: timeStampState,
      orderBy: selectedColumn.name.toLowerCase(),
      orderDirection: order
    }
    getTableData(paginationObject)
  }

  /**
   *@function searchBarHandler
   *@return void
   *@param event
   * @description To handle search on Designation page.
   */
  const searchBarHandler = (value: string) => {
    setSearchBar(value)
    const pagination = { page: currentPageState, limit: rowsPerPage, timestamps: timeStampState, q: (value).toLowerCase() }
    getTableData(pagination)
  }

  const handlePerPageLimit = (rowsPerPge: number, currentPage: number) => {
    setRowsPerPage(rowsPerPge)
    setCurrentPageState(currentPage)
  }

  return (
    <>
      <div>
        <Row className='mb-4'>
          <Col sm={12} md={6} lg={4} xl={3}>
            <FormControl
              type="text"
              className="form-control ms-auto search-bar"
              placeholder={`${t('DESIGNATION_PAGE.SEARCH_BAR_PLACEHOLDER')}`}
              onChange={(event) => searchBarHandler(event.target.value)}
              value={searchBar}
            />
          </Col>
        </Row>
      </div>
      <Card className="designation-table">
        <Card.Body>
          <Row>
            <Col>
              {isFetching ? (
                <div className="loading d-block mx-auto">
                  <div className="spinner-border"></div>
                </div>
              ) : tableBodyState.length === 0 ? (
                <div className="text-center font-weight-bold">{`${t('USER_LIST_PAGE.USER_TABLE.NO_USER')}`}</div>
              ) : (
                <DataTable
                  columns={columns}
                  data={tableBodyState}
                  className="table-with-pagination"
                  highlightOnHover
                  onRowClicked={(row) => gotoUserDetails(row.id)}
                  pagination
                  paginationServer
                  paginationDefaultPage={currentPageState}
                  paginationTotalRows={totalRows}
                  paginationPerPage={rowsPerPage}
                  onChangePage={(page, totalRows) => handlePageChange(page, totalRows)}
                  paginationComponentOptions={{
                    rowsPerPageText: `${t('DESIGNATION_PAGE.DESIGNATION_TABLE.TABLE.ROW_PER_PAGE')}`,
                    rangeSeparatorText: `${t('DESIGNATION_PAGE.DESIGNATION_TABLE.TABLE.RANGE_SELECTION')}`
                  }}
                  sortServer
                  onSort={handleSort}
                  defaultSortAsc={isAscending}
                  onChangeRowsPerPage={handlePerPageLimit}
                  defaultSortFieldId={sortedFieldId}
                />
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}

export default UserList
